module.exports = __webpack_public_path__ + "img/effect-ranking-1.58695e5b.gif";